let preRemoveStorage = {};

export const hasPreRemove = (key) => {
    return typeof preRemoveStorage[key] != 'undefined' && preRemoveStorage[key];
};
export const cancelPreRemove = (key) => {
    delete preRemoveStorage[key];
};
export const markPreRemove = (key) => {
    // Set timeout
    preRemoveStorage[key] = true;
};
export const binds = () => {};
